import React from 'react';
import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';
import * as TIMERANGE from '../../constants/timeRanges';
import styles from './styles/roi.module.scss';

function FreeTipImpact() {
  const {
    selectedTimeRange,
    consumerFreeTipAllocation,
    averageTipPriceWithoutFreeTips,
    averageTipPriceWithFreeTips,
    estimatedSavingsPerTip,
  } = useROIContext();
  const allocation = consumerFreeTipAllocation();

  if (allocation <= 0) {
    return null;
  }

  const allocationUnit = selectedTimeRange === TIMERANGE.weekly ? 'WEEK' : 'MONTH';

  return (
    <section className={styles.consumerFreeTipImpact}>
      <div className={styles.consumerFreeTipImpactTitle}>Free Tip Impact</div>
      <div className={styles.consumerFreeTipImpactMetrics}>
        <div className={styles.consumerFreeTipImpactMetric}>
          <div className={styles.consumerFreeTipImpactLabel}>Free Tip Allocation</div>
          <div className={styles.consumerFreeTipImpactValue}>{allocation}/{allocationUnit}</div>
        </div>
        <div className={styles.consumerFreeTipImpactMetric}>
          <div className={styles.consumerFreeTipImpactLabel}>Average Tip Price Without Free Tips</div>
          <div className={styles.consumerFreeTipImpactValue}>${convertToCurrency(averageTipPriceWithoutFreeTips())}</div>
        </div>
        <div className={styles.consumerFreeTipImpactMetric}>
          <div className={styles.consumerFreeTipImpactLabel}>Average Tip Price With Free Tips</div>
          <div className={styles.consumerFreeTipImpactValue}>${convertToCurrency(averageTipPriceWithFreeTips())}</div>
        </div>
        <div className={styles.consumerFreeTipImpactMetric}>
          <div className={styles.consumerFreeTipImpactLabel}>Estimated Savings Per Tip</div>
          <div className={styles.consumerFreeTipImpactValue}>${convertToCurrency(estimatedSavingsPerTip())}</div>
        </div>
      </div>
    </section>
  );
}

export default FreeTipImpact;
